
import { useAuthStore } from "@/lib/auth";

export function SidebarHeader() {
  const { user } = useAuthStore();

  return (
    <div className="py-4 px-2">
      <div className="flex items-center gap-2 px-2">
        <div className="rounded-md bg-hospital-primary p-1">
          <h2 className="text-white font-bold text-xl">AM</h2>
        </div>
        <h2 className="text-xl font-semibold text-hospital-primary">AM CARE</h2>
      </div>
      {user && (
        <div className="mt-2 px-2 py-2 text-sm">
          <div className="font-medium">Hello {user.name}</div>
          <div className="text-xs text-gray-500 capitalize">{user.role}</div>
        </div>
      )}
    </div>
  );
}
